"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 注册制审核-创业板详情
 */
var web_1 = __importDefault(require("../../../config/web"));
var fieldtools_1 = __importDefault(require("../../../src/modules/commonutil/fieldtools"));
var table_jbxx = $("#table_jbxx");
var table_jgxx = $("#table_jgxx");
var table_cwzb = $("#table_cwzb");
loadstep();
loadcontent();
var step1 = ["0101", "0102"], step2 = ["0201"], step3 = ["0301", "0302", "0303", "0304", "0305", "0306", "0307"], step4 = ["0401"], step5 = ["0402", "0403", "0404", "0405"];
function loadstep() {
    getdata({
        reportName: "RPT_GEM_REGIPO_CHECKPROCESS",
        columns: "NUM,CHECK_STATUS,CHECK_STATUS_CODE,CHECK_STAGE,END_DATE,IS_IT"
    }).then(function (json) {
        var _a;
        if (json && json.result && json.result.data.length > 0) {
            var sysdate = fieldtools_1["default"].dateformat(new Date(), "YYYYMMDD");
            var stepbox = $('.step');
            //遍历状态展示
            //0101 - 已受理
            //0102 - 新受理
            //0201 - 已问询
            //0301 - 通过
            //0302 - 未通过
            //0303 - 暂缓审议
            //0304 - 复审通过
            //0305 - 复审不通过
            //0306 - 上市委会议通过
            //0307 - 上市委会议未通过
            //0401 - 提交注册
            //0402 - 注册生效
            //0403 - 不予注册
            //0404 - 补充审核
            //0405 - 终止注册
            //0501 - 中止
            //0601 - 审核不通过
            //0602 - 撤回
            //0603 - 未在规定时限内回复
            //8888 - 最新申报日期
            //9999 - 合计
            var list = ((_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data) || [];
            var curStep = list.find(function (v) { return (v === null || v === void 0 ? void 0 : v.IS_IT) == 1; });
            var stepNum = getCurStep(curStep === null || curStep === void 0 ? void 0 : curStep.CHECK_STATUS_CODE);
            for (var i = 0; i < list.length; i++) {
                var item = list[i];
                var type = item.CHECK_STATUS_CODE;
                var date = item.END_DATE.substring(0, 10).replace(/-/g, '');
                //是否是已发生过的日期
                var b = date <= sysdate;
                // 已受理
                if (step1.includes(type) && stepNum >= 1) {
                    $('.step1F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step1F', stepbox).removeClass("left01").addClass("left03");
                    }
                }
                // 已问询
                if (step2.includes(type) && stepNum >= 2) {
                    $('.step2F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step2F', stepbox).removeClass("center01").addClass("center05");
                    }
                }
                // 上市会议
                if (step3.includes(type) && stepNum >= 3) {
                    $('.step3F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step3F', stepbox).removeClass("center01").addClass("center05");
                        $('.step3F .step_text', stepbox).html(item.CHECK_STATUS);
                    }
                }
                //提交注册
                if (step4.includes(type) && stepNum >= 4) {
                    $('.step4F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step4F', stepbox).removeClass("center01").addClass("center05");
                    }
                }
                //注册结果
                if (step5.includes(type) && stepNum == 5) {
                    $('.step5F .step_date', stepbox).html(fieldtools_1["default"].dateformat(item.END_DATE));
                    if (b) {
                        $('.step5F', stepbox).removeClass("center01").addClass("right02");
                        $('.step5F .step_text', stepbox).html(item.CHECK_STATUS);
                    }
                }
            }
            //判断最终状态 0501中止 0601不予注册 0602撤回 0603未在规定时限内回复
            switch (info.CHECK_STATUS_CODE) {
                case '0501':
                case '0601':
                case '0602':
                case '0603':
                    {
                        $(".center05:last", stepbox).removeClass("center05").addClass("center06").find(".step_text").html("<div>" + info.CHECK_STATUS + "<br/>" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "<div>");
                        ;
                        break;
                    }
            }
        }
    });
}
function loadcontent() {
    //infocode
    fieldtools_1["default"].isEmpty(info.INFO_CODE) ? undefined : $("#pdfurl").attr('href', "https://pdf.dfcfw.com/pdf/H2_" + info.INFO_CODE + "_1.pdf").show();
    //基本信息
    $(".ISSUER_NAME", table_jbxx).html(info.ISSUER_NAME); //发行人全称	ISSUER_NAME
    $(".ACCEPT_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.ACCEPT_DATE)); //受理日期	ACCEPT_DATE
    $(".SECURITY_NAME_ABBR", table_jbxx).html(info.SECURITY_NAME_ABBR); //公司简称	SECURITY_NAME_ABBR
    $(".FINANCE_AMT", table_jbxx).html(info.FINANCE_AMT); //融资金额	FINANCE_AMT
    $(".CHECK_STATUS", table_jbxx).html(info.CHECK_STATUS); //审核状态	CHECK_STATUS
    $(".UPDATE_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.UPDATE_DATE)); //更新日期	UPDATE_DATE
    $(".REG_ADDRESS", table_jbxx).html(info.REG_ADDRESS); //注册地	REG_ADDRESS
    $(".CSRC_INDUSTRY", table_jbxx).html(info.CSRC_INDUSTRY); //证监会行业	CSRC_INDUSTRY
    $(".RECOMMEND_ORG", table_jbxx).html(info.RECOMMEND_ORG); //保荐机构	RECOMMEND_ORG
    $(".SPONSOR", table_jbxx).html(info.SPONSOR); //保荐代表人	SPONSOR
    $(".ACCOUNT_FIRM", table_jbxx).html(info.ACCOUNT_FIRM); //会计师事务所	ACCOUNT_FIRM
    $(".SIGN_ACCOUNTANT", table_jbxx).html(info.SIGN_ACCOUNTANT); //签字会计师	SIGN_ACCOUNTANT
    $(".LAW_FIRM", table_jbxx).html(info.LAW_FIRM); //律师事务所	LAW_FIRM
    $(".SIGN_LAWYER", table_jbxx).html(info.SIGN_LAWYER); //签字律师	SIGN_LAWYER
    $(".EVALUATE_ORG", table_jbxx).html(info.EVALUATE_ORG); //评估机构	EVALUATE_ORG
    $(".SIGN_APPRAISER", table_jbxx).html(info.SIGN_APPRAISER); //签字评估师	SIGN_APPRAISER
    $(".TOLIST_MARKET", table_jbxx).html(info.TOLIST_MARKET); //拟上市地点	TOLIST_MARKET
    $(".STATE", table_jbxx).html(info.STATE); //证监会注册状态	STATE
    $(".END_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.END_DATE)); //证监会更新日期	END_DATE
    document.title = info.TOLIST_MARKET + "\u4F01\u4E1A _ \u6570\u636E\u4E2D\u5FC3 _ \u4E1C\u65B9\u8D22\u5BCC\u7F51";
    //机构信息
    getdata({
        reportName: "RPT_GEM_REGIPO_ORGINFO",
        columns: "REG_ADDRESS,FOUND_DATE,LEGAL_PERSON,CHAIRMAN,ORG_PROFILE,BUSINESS_SCOPE"
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            var data = json.result.data[0];
            $(".REG_ADDRESS", table_jgxx).html(data.REG_ADDRESS); //注册地	REG_ADDRESS
            $(".FOUND_DATE", table_jgxx).html(fieldtools_1["default"].dateformat(data.FOUND_DATE)); //成立日期	FOUND_DATE
            $(".LEGAL_PERSON", table_jgxx).html(data.LEGAL_PERSON); // 法人代表	LEGAL_PERSON
            $(".CHAIRMAN", table_jgxx).html(data.CHAIRMAN); // 董事长	CHAIRMAN
            $(".ORG_PROFILE", table_jgxx).html(data.ORG_PROFILE); //公司简介	ORG_PROFILE
            $(".BUSINESS_SCOPE", table_jgxx).html(data.BUSINESS_SCOPE); //经营范围	BUSINESS_SCOPE
        }
    });
    //财务指标
    getdata({
        reportName: "RPT_IPO_INDICATOR",
        columns: "SECURITY_CODE,SECURITY_NAME_ABBR,REPORTDATE,TOTAL_ASSETS,NET_ASSETS,MINORITY_EQUITY,TOTAL_OPERATE_INCOME,NETPROFIT,CAPITAL_RESERVE,UNASSIGN_RPOFIT,PARENT_BVPS,BASIC_EPS,DILUTED_EPS,PER_NETCASH_OPERATE,WEIGHTAVG_ROE",
        sortColumns: "REPORTDATE",
        sortTypes: -1,
        pageSize: 4,
        filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")(REPORTDATE<='" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "')"
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            for (var i = 0; i < 4; i++) {
                if (json.result.data[i])
                    loadcell(i + 1, json.result.data[i]);
                else
                    delcell(i + 1);
            }
        }
    });
    //最新公告
    $("#dataview_zxgg").emdataview({
        columns: {
            title: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"ellipsis\" style=\"width:600px;\" href=\"//pdf.dfcfw.com/pdf/H2_" + item.art_code + "_1.pdf\" title=\"" + value + "\">" + value + "</a>";
                }
            },
            column_name: {
                formatter: function (value, item, i, field) {
                    var _a;
                    return ((_a = item.columns[0]) === null || _a === void 0 ? void 0 : _a.column_name) || '-';
                }
            },
            notice_date: emfield.date
        }
    });
}
function getdata(opt) {
    return $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: "GET",
        dataType: "jsonp",
        data: $.extend({}, {
            filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")",
            columns: 'ALL',
            source: "WEB",
            client: "WEB"
        }, opt)
    });
}
function loadcell(index, data) {
    $(".REPORTDATE td", table_cwzb).eq(index + 1).html(fieldtools_1["default"].dateformat(data.REPORTDATE)); //报表日期	REPORTDATE
    $(".TOTAL_ASSETS td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_ASSETS, { omit: false, zoom: -8, num: 4 })); //总资产	TOTAL_ASSETS
    $(".NET_ASSETS td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.NET_ASSETS, { omit: false, zoom: -8, num: 4 })); //净资产	NET_ASSETS
    $(".MINORITY_EQUITY td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.MINORITY_EQUITY, { omit: false, zoom: -4, num: 2 })); //少数股东权益	MINORITY_EQUITY
    $(".TOTAL_OPERATE_INCOME td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_OPERATE_INCOME, { omit: false, zoom: -8, num: 4 })); //营业总收入	TOTAL_OPERATE_INCOME
    $(".NETPROFIT td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.NETPROFIT, { omit: false, zoom: -8, num: 4 })); //净利润	NETPROFIT
    $(".CAPITAL_RESERVE td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.CAPITAL_RESERVE, { omit: false, zoom: -4, num: 2 })); //资本公积	CAPITAL_RESERVE
    $(".UNASSIGN_RPOFIT td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.UNASSIGN_RPOFIT, { omit: false, zoom: -8, num: 4 })); //未分配利润	UNASSIGN_RPOFIT
    $(".PARENT_BVPS td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_BVPS)); //每股净资产	PARENT_BVPS
    $(".BASIC_EPS td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.BASIC_EPS)); //基本每股收益	BASIC_EPS
    $(".DILUTED_EPS td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.DILUTED_EPS)); //稀释每股收益	DILUTED_EPS
    $(".PER_NETCASH_OPERATE td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PER_NETCASH_OPERATE)); //每股现金流	PER_NETCASH_OPERATE
    $(".WEIGHTAVG_ROE td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.WEIGHTAVG_ROE)); //净资产收益率	WEIGHTAVG_ROE
}
function delcell(index) {
    $(".REPORTDATE td", table_cwzb).eq(index + 1).remove();
    $("tr:not(.REPORTDATE)", table_cwzb).find("td:eq(" + index + ")").remove();
}
/**
 * 获取当前进度步骤
 */
function getCurStep(CHECK_STATUS) {
    var back = 5;
    try {
        var allsteps = [step1, step2, step3, step4, step5];
        allsteps.forEach(function (step, index) {
            if (step.includes(CHECK_STATUS)) {
                back = index + 1;
            }
            ;
        });
        return back;
    }
    catch (error) {
        return 5;
    }
}
